module.exports = __webpack_public_path__ + "static/media/blue-bg.842626df.svg";